import { gql } from '@apollo/client';

export const SINGLE_UPLOAD = gql`
  mutation SingleUpload($file: Upload!) {
    singleUpload(file: $file) {
      Location
      Key
    }
  }
`;

export const REFRESH_ASSET_CACHE = gql`
  mutation RefreshAsset($paths: [String!]) {
    refreshAsset(paths: $paths)
  }
`;

export const GET_FILE_DIRECT_UPLOAD_DEPRECATED = gql`
  query GetFileDirectUpload(
    $action: FileDirectUploadAction!
    $mimeTypes: [String!]!
    $filename: String
  ) {
    getFileDirectUpload(action: $action, mimeTypes: $mimeTypes, filename: $filename) {
      fileKey
      url
      fields
    }
  }
`;

export const GET_DIRECT_UPLOAD = gql`
  query GetDirectUpload(
    $action: DirectUploadAction!
    $directUploadRequests: [DirectUploadRequest!]!
  ) {
    getDirectUpload(action: $action, directUploadRequests: $directUploadRequests) {
      fileKey
      url
      fields
      fileUploadId
    }
  }
`;
